// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPromoSchema {
  /** Тренд динамики цен (увеличение/уменьшение/стабильность) **/
  diff: EDiff;
  /** Промо текст **/
  text: string;
}
export enum EDiff {
  /** Уменьшение **/
  'Decrease' = 'decrease',
  /** Увеличение **/
  'Increase' = 'increase',
  /** Без изменения **/
  'NoChange' = 'noChange',
}
